export const POLICY_MANAGEMENT_EMPLOYEE_LIST = "POLICY_MANAGEMENT_EMPLOYEE_LIST";
export const POLICY_MANAGEMENT_EMPLOYEE_HISTORY_LIST = "POLICY_MANAGEMENT_EMPLOYEE_HISTORY_LIST";
export const POLICY_MANAGEMENT_EMPLOYEE_HISTORY_INFO = "POLICY_MANAGEMENT_EMPLOYEE_HISTORY_INFO";
export const HISTORY_POLICY_MANAGEMENT_EMPLOYEE_LIST = "HISTORY_POLICY_MANAGEMENT_EMPLOYEE_LIST";
